// extracted by mini-css-extract-plugin
export var connectionButton = "_bk-1";
export var connectionButtonFloating = "_bk-2";
export var connectionContainer = "_bk-0";
export var rightPanel = "_bk-6";
export var stepCard = "_bk-3";
export var stepCardSubtitle = "_bk-5";
export var stepCardText = "_bk-4";